import { render, staticRenderFns } from "./viewDataCon.vue?vue&type=template&id=29d96b52&scoped=true"
import script from "./viewDataCon.vue?vue&type=script&lang=js"
export * from "./viewDataCon.vue?vue&type=script&lang=js"
import style0 from "./viewDataCon.vue?vue&type=style&index=0&id=29d96b52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d96b52",
  null
  
)

export default component.exports